import React, { useState, useEffect } from 'react-x';
import { BREAKPOINT_DEFINITIONS } from '../../constants/config.js';
import { generateSourceSet } from '../../helpers/picture.js';
import { Image } from './Image.jsx';
import classNames from 'classnames';

export function Picture(props) {

  const { base, small, medium, large, xlarge, xxlarge, xxxlarge, alt, onClick, onLoad, options, className, testId, pictureClasses } = props;
  const [sources, setSources] = useState([]);
  const block = 'c-picture';

  useEffect(() => {
    setSources(generateSourceSet(BREAKPOINT_DEFINITIONS, {
      sm: small, 
      md: medium, 
      lg: large, 
      xl: xlarge, 
      xxl: xxlarge, 
      xxxl: xxxlarge
    }))
  },[small, medium, large, xlarge, xxlarge]);

  function renderSrcSets () {
    const sourceSet = sources.map((source) => {
      const {breakpoint, asset} = source;
      return <source media={`(min-width:${breakpoint}px)`} srcSet={asset}/>
    })
    return sourceSet
  };

  return (
    <picture className={ 
      classNames({
        [`${block}`]: true,
        [pictureClasses]: pictureClasses
      })}>
      {renderSrcSets()}
      <Image {...{
        alt,
        imageUrl: base,
        className,
        testId,
        onClick,
        onLoad,
        options
      }}/>
    </picture>
  )
};